import { useAPIClient } from './api_helper';

import * as url from "./url_helper";

const api = useAPIClient();

// Gets the logged in user data from local session


// //is user is logged in



// Tasks
// get Task


// Clients Api 
// export const getClientList = (para) => api.get(`${url.clientPath}/?page-size=1&page-number=${para?.page}`)
export const getClientList = (para) =>
  api.get(`${url.clientPath}`, { params: para });

export const getClienAlltList = (para) => api.get(`${url.clientPath}/${para}/?page-size=100`)